import { ListSubheader as MuiListSubheader, type ListSubheaderProps as MuiListSubheaderProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<MuiListSubheaderProps>;

export function ListSubheader(props: Props) {
  return <MuiListSubheader {...props} />;
}

export type { Props as ListSubheaderProps };
